import React, {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Icon,
  Typography,
  DialogContent,
  Dialog,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { getAdditionalSkusApi } from 'api/subscription';
import SkusForm from './SkusForm';
import SkusList from './SkusList';


const Skus = () => {
  const dispatch = useDispatch();
  const [sku, setSku] = useState();

  useEffect(() => {
    getAdditionalSkusApi({ dispatch });
  }, []);

  return (
    <Accordion
      elevation={25}
      className="mb-4"
    >
      <AccordionSummary
        expandIcon={<Icon>expand_more</Icon>}
      >
        <Typography variant="h5" className="text-brand m-2" title="Additional SKUs">Additional SKUs</Typography>
      </AccordionSummary>
      <AccordionDetails className="block">
        <SkusList setSku={setSku} />
        <Button
          color="primary"
          variant="contained"
          onClick={() => setSku({})}
          className="mb-8 ml-4"
        >
          <Icon className="mr-2">add</Icon>
          <span>Add New SKUs</span>
        </Button>
        <Dialog
          open={sku}
          onClose={() => setSku(null)}
          maxWidth={'md'}
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h4" className="mt-4">{sku?._id ? 'Edit Additional SKUs' : 'Create Additional SKUs'}</Typography>
          </DialogTitle>
          <DialogContent  className="m-4">
            <SkusForm sku={sku} setSku={setSku} />
          </DialogContent>
        </Dialog>
      </AccordionDetails>
    </Accordion>
  );
};

export default Skus;
